// removed by extract-text-webpack-plugin
module.exports = {"banner":"_2aGnwweNAmf7burJA8u6w_","banner__quotation":"_2YO6jpDJKVJ3H9ZsnCEWE8","banner__quotationText":"_3cTB9nMk5smvPV1ptGpcGx","banner__bubble":"_1q-5z492ui5S6DRAJTAlO2","banner__bubbleContainer":"_2Hbxc3SiUpMtfTxsZh4B5V","banner__bubbleText":"_2iGhUf3Pf8uYqwDnon2J_k","banner__quotationTextContainer":"_2VPlehjSshxuZNvv1ryO4G","banner__bubbleBorderTop":"Dg9ecbwv6rAIKTWL5LfiY","banner__bubbleBorderBottom":"_2bj6ZdqZec9a6zH1aoJGq8","banner__linkContainer":"UQejaTL7jGDLpPPlxR-hN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Banner/Banner.module.scss
// module id = 733
// module chunks = 0